export const ratings = [
  { value: 1, face: '😫', label: 'Horrible' },
  { value: 2, face: '😕', label: 'Flojo' },
  { value: 3, face: '😐', label: 'Normal' },
  { value: 4, face: '🙂', label: 'Bueno' },
  { value: 5, face: '🤩', label: 'Genial' }
]

export function ratingOf(value) {
  return ratings.find((r) => r.value === value)
}
